import { SidebarFooter, useSidebar } from 'components/ui/sidebar';
import { UProfileMenu } from '../u-profile-menu';
import LanguageSelector from '../language-selector/language-selector';

export function AppSidebarFooter() {
  const { open, isSidebarOverlay } = useSidebar();
  const showExpanded = open || isSidebarOverlay;

  if (!showExpanded) {
    return (
      <SidebarFooter className="mt-auto w-full shrink-0 items-center gap-3 !p-0 bg-transparent">
        <LanguageSelector variant="rail" />
        <div className="flex size-12 items-center justify-center rounded-full bg-grey-100 dark:bg-sidebar-pill-dark">
          <UProfileMenu variant="avatar" />
        </div>
      </SidebarFooter>
    );
  }

  return (
    <SidebarFooter className="mt-auto w-full shrink-0 gap-2 !p-0 bg-transparent">
      <UProfileMenu variant="pill" isDropdownIconRequired isFullNameRequired />
    </SidebarFooter>
  );
}
